module.exports = __webpack_public_path__ + "static/media/searchIconWhite.9d85609f.svg";